module.exports = __webpack_public_path__ + "static/img/DSC00631.09c5bd1d.jpg";